import cn from 'clsx';
import { forwardRef, HTMLAttributes, useMemo } from 'react';

import s from './GuideTitle.module.scss';

interface Props extends HTMLAttributes<HTMLDivElement> {
  titleType?: 'small' | 'medium' | 'large';
}

const GuideTitle = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { children, className, titleType = 'medium', ...rest } = props;

  const titleTypeClass = useMemo(() => s[`${titleType}`], [titleType]);
  return (
    <div className={cn(titleTypeClass, className)} ref={ref} {...rest}>
      {children}
    </div>
  );
});

export default GuideTitle;
